<template>
  <div class="cmp-booking-booking_details dt-details">
    <div class="dt-details--header"> {{$t('booking_details')}} </div>
    <div class="dt-details--body">
      <div class="dt-details--col">
        <div class="dt-details--row ut-flex">
          <DatePicker2
            id="start_date"
            :label="$t('start_date')"
            :value="cdate.start_date"
            @input="changeStartDate"
            lw="72px"
            cw="110px"
            bb="none"
            style="width: 100%"
            :canReset="false"
          />
          <!-- <div class="dt-details--label">{{$t('date')}}</div>
          <div class="dt-details--value" v-if="cdate.start_date">
            <div class="label-icon">
              <div class="label">{{cdate.start_date}}</div>
              <div class="icon">
                <v-menu
                  ref="startDateMenu"
                  :close-on-content-click="false"
                  v-model="startDateMenu"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  max-width="290px"
                  min-width="290px"
                >
                  <img
                    slot="activator"
                    class="dt-icon v6 h1 s1"
                    src="static/icons/calendar.svg"
                    alt
                  />
                  <v-date-picker :value="booking.start_date" full-width @input="changeStartDate"></v-date-picker>
                </v-menu>
              </div>
            </div>
          </div> -->
        </div>
        <div class="dt-details--row">
          <DatePicker2
            id="end_date"
            :class="isEndDateInvalid ? 'invalid' : ''"
            :title="
              isEndDateInvalid
                ? $t('the_end_date_cannot_be_before_the_start_date')
                : ''
            "
            :label="$t('end_date')"
            :value="cdate.end_date"
            @input="changeEndDate"
            lw="72px"
            cw="110px"
            bb="none"
            style="width: 100%"
            :canReset="false"
          />
          <!-- <div class="dt-details--label">{{ $t("end_date") }}</div>
          <div class="dt-details--value" v-if="cdate.end_date">
            <div class="label-icon">
              <div class="label">{{ cdate.end_date }}</div>
              <div class="icon">
                <v-menu
                  ref="endDateMenu"
                  :close-on-content-click="false"
                  v-model="endDateMenu"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  max-width="290px"
                  min-width="290px"
                >
                  <img
                    slot="activator"
                    class="dt-icon v6 h1 s1"
                    src="static/icons/calendar.svg"
                    alt
                  />
                  <v-date-picker
                    :value="booking.end_date"
                    full-width
                    @input="changeEndDate"
                  ></v-date-picker>
                </v-menu>
              </div>
            </div>
          </div> -->
        </div>
        <div class="dt-details--row">
          <TextField2
            :id="'date_name'"
            :placeholder="$t('date_name')"
            :label="$t('date_name')"
            :value="cdate.date_name"
            @blur="onTextFieldValueChange"
            lw="72px"
            cw="110px"
            bb="none"
            style="width: 100%"
          />
          <!-- <div class="dt-details--label">{{ $t("date_name") }}</div>
          <div class="dt-details--value" v-if="cdate" :title="cdate.date_name">
            <EditableSpan
              :value="cdate.date_name"
              @change="(e) => onBookingChange('date_name', e)"
            />
          </div> -->
        </div>
      </div>
      <div class="dt-details--col">
        <div class="dt-details--row">
          <TextField2
            :id="'venue'"
            :disabled="true"
            :noDisabledStyle="true"
            :placeholder="$t('venue')"
            :label="$t('venue')"
            :value="
              booking.location && booking.location.booking_location_name
                ? booking.location.booking_location_name
                : ''
            "
            :popup="
              booking.location && booking.location.booking_location_name
                ? VenueFuncs.getVenueInfo(booking.location)
                : ''
            "
            popupType="html"
            @blur="onTextFieldValueChange"
            lw="70px"
            cw="110px"
            bb="none"
            style="width: 92%"
            :icon="'search-bg-transparent'"
            :overflowIndicator="false"
            @iconClick="searchVenueClick"
          />
          <img
            @click.stop="(e) => onChangedQuestionnaireLockStatus('calendar_dates_venue')"
            :src="lockJson.calendar_dates_venue == 'lock' ? 'static/icons/booking/lock-closed.svg' : 'static/icons/booking/lock-open.svg'"
            class="dt-icon"
            :alt="$t('lock_status_in_questionnaire')"
            :title="$t('lock_status_in_questionnaire')"
          />
          <!-- <div class="dt-details--label">{{ $t("venue") }}</div>
          <div
            class="dt-details--value"
            :title="
              booking &&
              booking.location &&
              booking.location.booking_location_name
            "
          >
            
            <div class="label-icon">
              <div class="label">
                <InfoCard
                  :label="
                    booking.location && booking.location.booking_location_name
                      ? booking.location.booking_location_name
                      : ''
                  "
                  :infoString="
                    booking.location && booking.location.booking_location_name
                      ? VenueFuncs.getVenueInfo(booking.location)
                      : ''
                  "
                />
              </div>
              <div class="icon">
                <img
                  @click="searchVenueClick"
                  class="dt-icon v6 h1 s1"
                  src="static/icons/lupe.svg"
                  alt
                />
              </div>
            </div>
          </div> -->
        </div>
        <div class="dt-details--row">
          <TextField2
            :id="'city'"
            :placeholder="$t('city')"
            :label="$t('city')"
            :value="cdate.city"
            @blur="onTextFieldValueChange"
            lw="70px"
            cw="110px"
            bb="none"
            style="width: 100%"
          />
          <!-- <div class="dt-details--label">{{ $t("city") }}</div>
          <div class="dt-details--value" v-if="cdate.city" :title="cdate.city">
            <EditableSpan
              :value="cdate.city"
              @change="(e) => onBookingChange('city', e)"
            />
          </div> -->
        </div>
        <div class="dt-details--row">
          <Dropdown2
            :label="$t('country')"
            :placeholder="$t('select')+' ' + $t('country')"
            :options="countriesTV"
            :selected="selectedCountry"
            v-on:selectedChange="onCountryChange"
            lw="70px"
            bb="none"
            style="width: 100%"
          />
          <!-- <div class="dt-details--label">{{ $t("country") }}</div>
          <div
            class="dt-details--value"
            v-if="selectedCountry && selectedCountry.text"
            :title="selectedCountry && selectedCountry.text"
          >
            <Dropdown
              :options="countriesTV"
              :selected="selectedCountry"
              v-on:selectedChange="onCountryChange"
              :config="dropdownConfig"
              :placeholder="$t('country')"
            ></Dropdown>
          </div> -->
        </div>
      </div>
      <div class="dt-details--col">
        <div class="dt-details--row">
          <TextField2
            :id="'promoter'"
            :label="$t('promoter')"
            :placeholder="$t('promoter')"
            :disabled="true"
            :noDisabledStyle="true"
            :value="booking.promoter ? getName(booking.promoter) : ''"
            :popup="booking.promoter ? this.promoterInfoString() : ''"
            popupType="html"
            @blur="onTextFieldValueChange"
            lw="70px"
            cw="110px"
            bb="none"
            style="width: 92%"
            :icon="'search-bg-transparent'"
            :overflowIndicator="false"
            @iconClick="searchPromoterClick"
          />
          <img
            @click.stop="(e) => onChangedQuestionnaireLockStatus('calendar_dates_promoter')"
            :src="lockJson.calendar_dates_promoter == 'lock' ? 'static/icons/booking/lock-closed.svg' : 'static/icons/booking/lock-open.svg'"
            class="dt-icon"
            :alt="$t('lock_status_in_questionnaire')"
            :title="$t('lock_status_in_questionnaire')"
          />
          <!-- <div class="dt-details--label">{{ $t("promoter") }}</div>
          <div
            class="dt-details--value"
            :title="booking.promoter ? getName(booking.promoter) : ''"
          >
            <div class="label-icon">
              <div class="label">
                <InfoCard
                  :label="booking.promoter ? getName(booking.promoter) : ''"
                  :infoString="
                    booking.promoter
                      ? ContactFuncs.getContactInfo(booking.promoter)
                      : ''
                  "
                  :childComponent="{
                    component: promoterInfoCardComp,
                    props: { booking },
                  }"
                />
              </div>
              <div class="icon">
                <img
                  @click="searchPromoterClick"
                  class="dt-icon v6 h1 s1"
                  src="static/icons/lupe.svg"
                  alt
                />
              </div>
            </div>
          </div> -->
        </div>
        <div class="dt-details--row">
          
          <TextField2
            :id="'contact'"
            :label="$t('contact')"
            :placeholder="$t('contact')"
            :disabled="true"
            :noDisabledStyle="true"
            :value="booking.promoter2 ? getName(booking.promoter2) : ''"
            :popup="
              booking.promoter2
                ? ContactFuncs.getContactInfo(booking.promoter2)
                : ''
            "
            popupType="html"
            @blur="onTextFieldValueChange"
            lw="70px"
            cw="110px"
            bb="none"
            style="width: 92%;"
            :icon="'search-bg-transparent'"
            :overflowIndicator="false"
            @iconClick="searchContactClick"
          />
          <img
            @click.stop="(e) => onChangedQuestionnaireLockStatus('calendar_dates_contact')"
            :src="lockJson.calendar_dates_contact == 'lock' ? 'static/icons/booking/lock-closed.svg' : 'static/icons/booking/lock-open.svg'"
            class="dt-icon"
            :alt="$t('lock_status_in_questionnaire')"
            :title="$t('lock_status_in_questionnaire')"
          />

          <!-- <div class="dt-details--label">{{ $t("contact") }}</div>
          <div class="dt-details--value">
            <div class="label-icon">
              <div class="label">
                <InfoCard
                  :label="booking.promoter2 ? getName(booking.promoter2) : ''"
                  :infoString="
                    booking.promoter2
                      ? ContactFuncs.getContactInfo(booking.promoter2)
                      : ''
                  "
                />
              </div>
              <div class="icon">
                <img
                  @click="searchContactClick"
                  class="dt-icon v6 h1 s1"
                  src="static/icons/lupe.svg"
                  alt
                />
              </div>
            </div>
          </div> -->
        </div>
        <div class="dt-details--row">
          <Dropdown2
            :label="$t('currency')"
            :placeholder="$t('select')+' ' + $t('currency')"
            :options="currenciesTV"
            :selected="selectedCurrency"
            v-on:selectedChange="onCurrencyChange"
            :config="dropdownConfig"
            lw="70px"
            bb="none"
            style="width: 100%"
          />
          <!-- <div class="dt-details--label">{{ $t("currency") }}</div>
          <div
            class="dt-details--value"
            v-if="selectedCurrency && selectedCurrency.text"
            :title="selectedCurrency && selectedCurrency.text"
          >
            <Dropdown
              :options="currenciesTV"
              :selected="selectedCurrency"
              v-on:selectedChange="onCurrencyChange"
              :config="dropdownConfig"
              :placeholder="$t('currency')"
            ></Dropdown>
          </div> -->
        </div>
      </div>
      <div class="dt-details--col">
        <div class="dt-details--row">
          <Dropdown2
            :label="$t('staff')"
            :placeholder="$t('select')+' ' + $t('staff')"
            :options="usersTV"
            :selected="selectedUser"
            v-on:selectedChange="onUserChange"
            :config="dropdownConfig"
            lw="70px"
            bb="none"
            style="width: 100%"
          />
          <!-- <div class="dt-details--label">{{ $t("staff") }}</div>
          <div
            class="dt-details--value"
            :title="selectedUser && selectedUser.text"
          >
            <Dropdown
              :options="usersTV"
              :selected="selectedUser"
              v-on:selectedChange="onUserChange"
              :config="dropdownConfig"
              :placeholder="$t('staff')"
            ></Dropdown>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getName } from "../../../contacts/models/contact-details.model";
import EditableSpan from "@/plugins/editable-span/editable-span";
import Dropdown from "@/plugins/dropdown/dropdown";
import { createCountriesTV } from "../../../../models/country.model";
import { createUserTV } from "../../../../models/user.model";
import { createDropdownConfig } from "../../../../plugins/dropdown";
import InfoCard from "../../../../dt-plugins/info-card/info-card.vue";
import { ContactFuncs } from "../../../contacts/models/contacts.model";
import { VenueFuncs } from "../../models/venue.model";
import PromoterInfoCard from "./booking-details-promoter";

export default {
  components: {
    EditableSpan,
    Dropdown,
    InfoCard,
  },
  props: ["booking", "lockJson"],
  data: function () {
    return {
      endDateMenu: null,
      startDateMenu: null,
      dropdownConfig: createDropdownConfig({
        iconHoverStyle: 1,
      }),
      ContactFuncs,
      VenueFuncs,
      promoterInfoCardComp: PromoterInfoCard,
    };
  },
  computed: {
    cdate: function () {
      return this.booking?.cdate || {};
    },
    currenciesTV: function () {
      return (
        this.booking?.currencies?.map((e) => {
          return {
            text: e.currency_iso,
            value: e.currency_id,
          };
        }) || []
      );
    },
    countriesTV: function () {
      return createCountriesTV(this.booking?.countries || []);
    },
    usersTV: function () {
      return createUserTV(this.booking?.users || []);
    },
    selectedCountry: function () {
      return this.countriesTV.find(
        (e) => e.value == this.booking?.cdate?.country
      );
    },
    selectedCurrency: function () {
      return this.currenciesTV.find(
        (e) => e.value == (this.booking && this.cdate && this.cdate.currency_id)
      );
    },
    selectedUser: function () {
      return this.usersTV.find(
        (e) => e.value == (this.booking && this.cdate && this.cdate.user_id)
      );
    },
    isEndDateInvalid() {
      const startDate = new Date(this.cdate.start_date);
      const endDate = new Date(this.cdate.end_date);

      if (endDate.getTime() < startDate.getTime()) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    searchVenueClick: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "booking-wizard",
          tab: "venue",
        },
      });
    },
    searchPromoterClick: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "booking-wizard",
          tab: "promoter",
        },
      });
    },
    searchContactClick: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "booking-wizard",
          tab: "contact",
        },
      });
    },
    getName: getName,
    changeEndDate: function ({ name, value }) {
      // this.endDateMenu = false;
      // console.log(value);
      // const name = "end_date";
      this.onBookingChange(name, value);
    },
    changeStartDate: function ({ name, value }) {
      // this.startDateMenu = false;
      // const name = "start_date";
      this.onBookingChange(name, value);
    },
    onCurrencyChange: function (event) {
      const value = event.value;
      this.onBookingChange("currency_id", value);
    },
    onCountryChange: function (event) {
      const value = event.value;
      this.onBookingChange("country", value);
    },
    onBookingChange: function (name, value) {
      this.$emit("updated", {
        name,
        value,
        item: this.cdate,
      });
    },
    onUserChange: function (event) {
      const value = event.value;
      this.onBookingChange("user_id", value);
    },

    promoterInfoString: function () {
      const booking = this.booking || {};
      const promoter = this.booking?.promoter || {};
      const promoter_id = this.booking?.promoter_id || {};
      // return ContactFuncs.getContactInfo(promoter);
      console.log({
        promoter,
        "booking.promoter_related_contacts": booking.promoter_related_contacts,
      });
      return `
        ${ContactFuncs.getPromoterInfo(promoter, promoter_id)}
        ${
          booking?.promoter_related_contacts &&
          booking.promoter_related_contacts.length > 0
            ? `
            <div style="height: 1px; background-color: var(--text-accent); width: 100%; margin: 4px 0px"></div>
            <div class="dt-list v2">
        ${(booking?.promoter_related_contacts || [])
          .map(
            (contact, index) => `
            
          <div class="dt-list-item" style="height: 30px">
          <div class="dt-list-item--column pad--5">${contact.contact}</div>
          <div class="dt-list-item--column pad--5">${contact.relation}</div>
          <div class="dt-list-item--column contact-options" style="display: flex; width: 60px; max-width: 60px">
            <a class="dt-icon-container" style="display: block" href="${
              contact["phone1"] ? "tel:" + contact["phone1"] : "javascript:void(0)"
            }">
               
                  <img src="static/icons/phone.svg" class="dt-icon v5 s1" alt="Call"  class="${
                    !contact["phone1"] ? "inactive" : ""
                  }" />
                  
              </a>
              <a class="dt-icon-container" style="display: block" href="${
                contact["email1"] ? "mailto:" + contact["email1"] : "javascript:void(0)"
              }">
              
                  <img src="static/icons/email/email-grey.svg" class="dt-icon v5 s1" alt="Email"  class="${
                    !contact["email1"] ? "inactive" : ""
                  }" />
                  
              </a>
          </div>
        </div>`
          )
          .join("")}
      </div>`
            : ""
        }
      `;
    },
    onTextFieldValueChange({ name, value }) {
      this.onBookingChange(name, value);
    },
    onChangedQuestionnaireLockStatus(propertyName) {
      let lockJson = this.lockJson;
      if(lockJson.hasOwnProperty(propertyName)){
        delete lockJson[propertyName];
      }else{
        lockJson[propertyName] = 'lock';
      }
      this.onBookingChange("lock_json", JSON.stringify(lockJson));
    },
    //MARK: Methods
  },
};
</script>

<style lang="scss">
.cmp-booking-booking_details {
  .dt-details--row {
    padding-left: 0px !important;
  }
}
</style>
